import { Amplify } from 'aws-amplify';
import amplifyConfig from './app/amplify/aws-exports';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

Amplify.configure(amplifyConfig);

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
